import { Form, message, Modal } from "antd";
import { Rule } from "antd/lib/form";
import { productCategoryApi } from "api/product-category.api";
import { AppButton, AppInput, AppTextArea } from "components/antd-ui";
import { InputNumber } from "components/Input/InputNumber";
import React, { useEffect, useState } from "react";
import { ModalStatus } from "types/modal";
import { ProductCategory } from "types/product-category";

const rules: Rule[] = [{ required: true }];

export const ProductCategoryModal = ({
  visible,
  status,
  productCategory,
  onClose,
  onSubmitOk,
  shopId,
}: {
  visible: boolean;
  status: ModalStatus;
  shopId: number;
  productCategory: Partial<ProductCategory>;
  onClose: () => void;
  onSubmitOk: () => void;
}) => {
  const [form] = Form.useForm<ProductCategory>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (status == "create" && visible) {
      form.resetFields();
    }
  }, [visible, status]);

  useEffect(() => {
    form.setFieldsValue({ ...productCategory });
    return () => {};
  }, [productCategory]);

  const createData = async () => {
    const valid = await form.validateFields();
    const data = { productCategory: form.getFieldsValue(), shopId };

    setLoading(true);
    try {
      const res = await productCategoryApi.create(data);
      message.success("Tạo thành công");
      onClose();
      onSubmitOk();
    } finally {
      setLoading(false);
    }
  };

  const updateData = async () => {
    const valid = await form.validateFields();
    const data = { productCategory: form.getFieldsValue(), shopId };
    setLoading(true);
    try {
      const res = await productCategoryApi.update(
        productCategory?.id || 0,
        data
      );
      message.success("Cập nhật thành công");
      onClose();
      onSubmitOk();
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (status === "create") {
      await createData();
      return;
    }

    await updateData();
  };

  return (
    <Modal
      style={{ top: 15 }}
      onCancel={onClose}
      open={visible}
      title={
        <h1 className="text-xl font-bold text-center">
          {status === "create" ? "Tạo mới danh mục" : "Cập nhật danh mục"}
        </h1>
      }
      footer={null}
      width={700}
      className="app-form-modal"
    >
      <div className="app-form-modal__body">
        <section className="app-form-modal__section">
          <Form layout="vertical" form={form}>
            <Form.Item label="Tên danh mục" name="name" rules={rules}>
              <AppInput placeholder="Nhập tên danh mục" />
            </Form.Item>

            <Form.Item label="Giới thiệu" name="description">
              <AppTextArea rows={3} placeholder="Nhập giới thiệu" />
            </Form.Item>

            <Form.Item
              label="Vị trí (Thấp nhất là trên top)"
              name="position"
              rules={rules}
            >
              <InputNumber />
            </Form.Item>
          </Form>
        </section>
      </div>
      <div className="ant-modal-footer">
        <div className="flex gap-2 justify-end">
          <AppButton onClick={onClose}>Hủy</AppButton>
          <AppButton tone="primary" loading={loading} onClick={handleSubmit}>
            {status === "create" ? "Xác nhận" : "Cập nhật"}
          </AppButton>
        </div>
      </div>
    </Modal>
  );
};
